import Vue from "vue";
import Vuex from "vuex";
import { setToken, getToken, removeToken } from "@/utils/lostorage";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // token
    tokenObj: {
      userid: getToken("userid") || "",
      token: getToken("token") || "",
    },
    userInfo: {},
    // COS 存储桶前缀
    COSdata: "https://wangyiquan-1251215832.cos.ap-guangzhou.myqcloud.com",
    rooutePushData: false,
    circleData: {},
  },
  mutations: {
    setToken(state, value) {
      if (value.value_key === "token") {
        state.tokenObj.token = value.value;
      } else if (value.value_key === "userid") {
        state.tokenObj.userid = value.value;
      }
      /* setValue(token.token, token.userid) */
      setToken(value.value_key, value.value);
    },
    // 退出
    logout(state) {
      state.tokenObj = {};
      state.userInfo = {};
      removeToken("token");
      removeToken("userid");
    },
    setCircleDataFn(state, value) {
      state.circleData = value;
    },
  },
  actions: {},
});
